<template>
  <v-layout 
    column 
      >
      <v-flex
        pt-4
        mt-5>
        <clients-search-panel 
          :route="route"/>
      </v-flex>
      <v-flex
        pt-1
        mb-3>
        <clients-panel />
      </v-flex>
    </v-layout>
</template> 

<script>
import {mapState} from 'vuex'
import ClientsSearchPanel from './ClientsSearchPanel'
import ClientsPanel from './ClientsPanel'
import EventBus from '@/main'
import {ATTR_MAP, addSign, fixName, ATTR_LIST_B, ATTR_LIST_R, ATTR_LIST_RSMP, BUSINESS, SCHOOL, SPORTS, SD} from '@/components/globals/consts.js'

export default {
	components: {
		ClientsSearchPanel,
		ClientsPanel
	},
	data () {
		return {
      route: "clients",
      attrList: null // ATTR_LIST_B
		}
	},
	computed: {
		...mapState([
      'isUserLoggedIn',
      'testType'
		])
  },
  async created() {
    if (this.testType === BUSINESS || this.testType === SPORTS || this.testType == SCHOOL) { 
        this.attrList = ATTR_LIST_B
      }
      else if (this.testType === SD) {
        this.attrList = ATTR_LIST_R
      }
      // else if (this.testType === SCHOOL ){
      //   this.attrList = ATTR_LIST_RSMP
      // }
  },
  async mounted () {
    
    if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
    }
    //this.loaded = true
  },
    beforeDestroy() {
    try {
     // this.clients = null
      this.attrList = null
    } catch (err) {
      console.log(err);
    }
  },
}  
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Clients/ClientsIndex.vue